var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 1.66602H6.66675C3.33341 1.66602 1.66675 3.33268 1.66675 6.66601V17.4993C1.66675 17.9577 2.04175 18.3327 2.50008 18.3327H13.3334C16.6667 18.3327 18.3334 16.666 18.3334 13.3327V6.66601C18.3334 3.33268 16.6667 1.66602 13.3334 1.66602Z",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7583 6.53248L6.43332 10.8575C6.26666 11.0241 6.10833 11.3492 6.07499 11.5825L5.84166 13.2325C5.75833 13.8325 6.17499 14.2492 6.77499 14.1658L8.42497 13.9325C8.65831 13.8992 8.98333 13.7408 9.15 13.5742L13.475 9.24915C14.2167 8.50748 14.575 7.64082 13.475 6.54082C12.375 5.43248 11.5083 5.78248 10.7583 6.53248Z",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 7.15039C10.5083 8.45872 11.5333 9.49206 12.8499 9.85872",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/messageEdit.34f674e7f0b6d453b82618015fe5c3e2.svg";
export { ForwardRef as ReactComponent };